<script>
	import { navigate } from 'svelte-routing';
	import { show_sidebar } from '../../app-store';
	import { onMount } from 'svelte';

	let email = '';
	let emailError = '';
	let isLoading = false;
	let formValid = false;

	onMount(() => {
		app.chat_manager.hide();
	});

	function validateEmail(value) {
		const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!reg.test(value)) {
			emailError = 'Please enter a valid email';
			formValid = false;
			return false;
		}
		emailError = '';
		formValid = true;
		return true;
	}

	async function handleSubmit() {
		if (!validateEmail(email)) {
			app.toast_msg.show(emailError);
			return;
		}

		isLoading = true;
		try {
			const { status } = await app.lucep_ai.request_otp(email);
			if (status === "ok") {
				app.toast_msg.show("An OTP has been sent to your email");
				navigate(`/otp/${email}`);
			}
		} catch (err) {
			if (err.substatus === "too_many_requests") {
				// The user has sent otp request before, but maybe by accident refreshed the page
				// So route to otp screen
				navigate(`/otp/${email}`);
				return;
			}
			app.toast_msg.show("Error requesting OTP: " + err.msg);
			console.error("Error requesting OTP:", err.msg);
		} finally {
			isLoading = false;
		}
	}
</script>

<div id="login" class="login-container">
	<div class="login-box panel">
		<h1 class="panel-title">Login</h1>
		<p class="panel-subtitle">Enter your email to get started.</p>	
		<form on:submit|preventDefault={handleSubmit}>
			<div class="field-email">
				<label for="email">Email</label>
				<input 
					id="email"
					type="email"
					bind:value={email}
					on:blur={() => validateEmail(email)}
					placeholder="yourname@example.com"
					autocomplete="email"
					required
					class="field-input"
				/>
			</div>
			{#if emailError}
				<span class="error-message">{emailError}</span>
			{/if}
			
			<div class="field-btn-login">
				<button 
					id="btn-login"
					type="submit"
					class="btn btn-primary btn-full-width"
					disabled={isLoading}
				>
					{#if isLoading}
						<span class="spinner me-1 "></span>
						<span>Login</span>
					{:else}
						Login
					{/if}
				</button>
			</div>
		</form>
	</div>
</div>

<style>
	#btn-login {
		border-radius: 0.55rem;
	}
	.error-message {
		color: red;
		font-size: 0.8rem;
		margin-bottom: 0.5rem;
		display: block;
		margin-left: 6px;
	}
	
	.spinner {
		display: inline-block;
		width: 1em;
		height: 1em;
		border: 2px solid rgba(255,255,255,0.3);
		border-radius: 50%;
		border-top-color: white;
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		to { transform: rotate(360deg); }
	}
</style>

